<template>
    <b-navbar type="dark" class="header flex-shrink-0">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand href="#" @click="updateApp">
          <div>
            <img class="logo" src="/static/logo.png"/>
          </div>
        </b-navbar-brand>
        <div v-if="restPoint" class="ml-2 mr-2">
          <span class="d-flex align-items-center fw-bold font-weight-bold" style="color: #fff;">
            <icon name="map-marker-alt" class="mr-2"></icon> {{restPoint.address}}
          </span>
        </div>
        <a
          v-if="isShowMemoBtn && memoUrl && memoUrl !== '<none>'"
          :href="memoUrl"
          class="btn btn-secondary mr-2"
          target="_blank"
        >
          Памятка
        </a>
        <wrapper-worker-stats v-if="userRole === USER_ROLE_CALL_CENTER"/>
        <div v-if="userRole === USER_ROLE_CALL_CENTER" class="d-flex align-items-center">
          <time-delivery-form
            :current-value="pickupDeliveryStats"
            class="ml-3"
            @updated-time="setStatsDelivery(true, $event.hours, $event.minutes)"
          >
            <span slot="header" class="">Самовывоз:</span>
          </time-delivery-form>
          <time-delivery-form
            class="ml-3"
            :current-value="delDeliveryStats"
            @updated-time="setStatsDelivery(false, $event.hours, $event.minutes)"
          >
            <span slot="header">Доставка:</span>
          </time-delivery-form>
        </div>
        <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav class="ml-auto d-flex flex-wrap">
                <slot name="navbar-display" class="mr-2 text-white"></slot>
                <preorders-print-picker class="mr-5" v-if="userRole === USER_ROLE_LOGISTICIAN"></preorders-print-picker>
                <worker-action
                  v-if="userRole !== null"
                  @showOrHideOrdersWindow="showOrHideOrdersWindow"
                />
                <a
                  v-if="isShowCookerRatingBtn && cookerRatingUrl && cookerRatingUrl !== '<none>'"
                  class="btn btn-secondary mr-2"
                  :href="cookerRatingUrl"
                  target="_blank"
                >
                  Рейтинг
                </a>
                <b-button
                  v-if="isShowExitBtn"
                  size="sm"
                  @click="$userControl.logout()"
                >
                  Выйти
                </b-button>
            </b-navbar-nav>

            <b-dropdown
              v-if="isCourier"
              text="Меню"
              class="ml-1"
              right
            >
              <b-dropdown-item to="/deliveryOrder">Доставки</b-dropdown-item>
              <b-dropdown-item to="/courierStats">Статистика</b-dropdown-item>
              <b-dropdown-item
                v-if="courierRatingUrl && courierRatingUrl !== '<none>'"
                :href="courierRatingUrl"
                target="_blank"
              >
                Рейтинг
              </b-dropdown-item>
              <b-dropdown-item
                v-if="memoUrl && memoUrl !== '<none>'"
                :href="memoUrl"
                target="_blank"
              >
                Памятка
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item @click="$userControl.logout()">
                Выйти
              </b-dropdown-item>
            </b-dropdown>
        </b-collapse>
    </b-navbar>
</template>

<script>
import WrapperWorkerStats from './modals/WrapperWorkerStats'
import PreordersPrintPicker from './PreordersPrintPicker'
import {USER_ROLE_GUEST} from '@/constants/roles'
import metaQueries from '../graphql/metaQueries'
import {
  USER_ROLE_ACCOUNTING_WORKERS,
  USER_ROLE_CALL_CENTER,
  USER_ROLE_COLD_COOKER,
  USER_ROLE_COLD_CUTTER,
  USER_ROLE_DELIVERY_COURIER,
  USER_ROLE_HOT_COOKER,
  USER_ROLE_LOGISTICIAN,
  USER_ROLE_SUPER_LOGISTICIAN,
  USER_ROLE_PIZZA_COOKER,
  USER_ROLE_PIZZA_DOUGH,
  USER_ROLE_WORKSHOPS_OVERALL
} from '../constants/roles'
import TimeDeliveryForm from './TimeDeliveryForm'
import WorkerAction from './WorkerAction.vue'
import orderFunc from '../functionsLib/orderFunc'
import configQueries from '../graphql/config'
import loginControl from '../helpers/loginControl'

export default {
  name: 'NavbarHeader',
  data () {
    return {
      USER_ROLE_GUEST,
      USER_ROLE_LOGISTICIAN,
      USER_ROLE_DELIVERY_COURIER,
      USER_ROLE_PIZZA_DOUGH,
      USER_ROLE_PIZZA_COOKER,
      USER_ROLE_CALL_CENTER,
      deliveryStat: [],
      timerInterval: null,
      onlineClass: 'user-online',
      offlineClass: 'user-offline',
      restPoint: null
    }
  },
  apollo: {
    courierRatingUrl: {
      query: configQueries.getConfigRecord,
      skip () {
        return !this.isCourier
      },
      variables: {
        param: 'courier_rating_url'
      },
      update (data) {
        return data.allConfigs.nodes[0].value
      }
    },
    memoUrl: {
      query: configQueries.getConfigRecord,
      skip () {
        return !(this.isShowMemoBtn || this.isCourier)
      },
      variables: {
        param: 'crm_memo_btn_link'
      },
      update (data) {
        return data.allConfigs.nodes[0].value
      }
    },
    cookerRatingUrl: {
      query: configQueries.getConfigRecord,
      skip () {
        return !this.isShowCookerRatingBtn
      },
      variables: {
        param: 'cooker_rating_url'
      },
      update (data) {
        return data.allConfigs.nodes[0].value
      }
    }
  },
  components: {
    TimeDeliveryForm,
    PreordersPrintPicker,
    WrapperWorkerStats,
    WorkerAction
  },
  methods: {
    updateApp () {
      location.reload(true)
    },
    showOrHideOrdersWindow (val) {
      this.$root.$refs.OrderInfo.showOrHideOrdersWindow(val)
    },
    setStatsDelivery (pickup, hours, minutes) {
      hours = hours || 0
      minutes = minutes || 0
      this.$apollo.mutate({
        mutation: metaQueries.SET_DELIVERY_STATS,
        variables: {
          pickup,
          hours,
          minutes
        }
      }).then(() => {
        this.getDeliveryStats()
      })
    },
    getDeliveryStats () {
      if (this.$userControl.jwtParsed !== null && this.$userControl.jwtParsed.role === USER_ROLE_CALL_CENTER) {
        this.$apollo.query({
          query: metaQueries.GET_DELIVERY_STATS,
          fetchPolicy: 'network-only'
        })
          .then((getInfo) => {
            this.deliveryStat = getInfo.data.getDeliveryStats.nodes
          })
      }
    },
    async determineRestPoint () {
      if (this.$userControl.jwtParsed) {
        let restPoint = await orderFunc.determineRestPoint.call(this)

        if (restPoint) {
          this.restPoint = restPoint
        }
      }
    }
  },
  async created () {
    await this.determineRestPoint()
    this.getDeliveryStats()
    this.timerInterval = setInterval(this.deliveryStat, 30000)
  },
  mounted () {
    loginControl.run()
  },
  destroyed () {
    clearInterval(this.timerInterval)
    loginControl.destroy()
  },
  computed: {
    userRole () {
      return this.$userControl.jwtParsed ? this.$userControl.jwtParsed.role : null
    },
    pickupDeliveryStats () {
      let item = this.deliveryStat.filter(item => item.pickup === true)
      return item ? item[0] : item
    },
    delDeliveryStats () {
      let item = this.deliveryStat.filter(item => item.pickup === false)
      return item ? item[0] : item
    },
    isCourier () {
      return this.userRole === USER_ROLE_DELIVERY_COURIER
    },
    isShowExitBtn () {
      const jwtParsed = this.$userControl.jwtParsed

      if (!jwtParsed) return false

      const isIdTypeWorkshop = jwtParsed.id_type_workshop === null
      const isNotGuestOrCouriere = ![USER_ROLE_GUEST, USER_ROLE_DELIVERY_COURIER].includes(this.$user.get().role)

      return isIdTypeWorkshop && isNotGuestOrCouriere
    },
    isShowMemoBtn () {
      return [
        USER_ROLE_CALL_CENTER,
        USER_ROLE_LOGISTICIAN,
        USER_ROLE_SUPER_LOGISTICIAN
      ].includes(this.userRole)
    },
    isShowCookerRatingBtn () {
      const userControl = this.$userControl
      const jwtParsed = userControl.jwtParsed

      if (!jwtParsed || !jwtParsed.role) return false

      return [
        USER_ROLE_COLD_COOKER,
        USER_ROLE_COLD_CUTTER,
        USER_ROLE_HOT_COOKER,
        USER_ROLE_PIZZA_COOKER,
        USER_ROLE_ACCOUNTING_WORKERS,
        USER_ROLE_WORKSHOPS_OVERALL
      ].includes(jwtParsed.role)
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    background-color: #26323d;
  }
  .user-online {
    color: green;
  }
  .user-offline {
    color: red;
  }
  .logo {
    width: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavbarHeader.vue